import React from "react";
import { QueryRenderer, createFragmentContainer, graphql } from "react-relay";
import environment from "./AuthEnv";
import AnalysePageWrapper from "./AnalysePageWrapper";
// import Loader from "./components/Loader";
import Spinner from "./Spinner";

const selectedPostQuery = graphql`
	query AnalysePageContainerQuery(
		$source_In: [ID]
		$orderBy: [String]
		$searchTerms: [String]
        $filterTerms: [String]
        $selectedSentimentPostIds: [ID]
        $allSubscriptions: Boolean
	) {
		selectedPosts(
			source_In: $source_In
			orderBy: $orderBy
			searchTerms: $searchTerms
            filterTerms: $filterTerms
            selectedSentimentPostIds: $selectedSentimentPostIds
            allSubscriptions: $allSubscriptions
			first: 100
		) {
			...AnalysePageWrapper_analyse_Posts
		}
	}
`;

function AnalysePageContainer(props) {
	const { isParent, selectedSourceId, selectedNodeId } = props.settings;
	// const sourceId_List = props.settings.selectedSourceId;
	// let isParent = props.settings.isParent;
	let sourceId_List = isParent ? selectedSourceId : selectedNodeId;
	let orderFields = ["-created"];
	const user = props.user;
	const settings = props.settings;
    const { allSubscriptions } = props.settings;

	return (
		<QueryRenderer
			environment={environment}
			query={selectedPostQuery}
			variables={{
				source_In: sourceId_List,
				orderBy: orderFields,
				searchTerms: [],
                filterTerms: [],
                selectedSentimentPostIds: [],
                allSubscriptions: allSubscriptions
			}}
			render={({ error, props }) => {
				if (error) {
					return <div>Error!</div>;
				}
				if (!props) {
					return (
						<div>
							<Spinner isLoading={true} />{" "}
						</div>
					);
				}
				return (
					<div>
						<AnalysePageWrapper
							settings={settings}
							user={user}
							analyse_Posts={props.selectedPosts}
						/>
					</div>
				);
			}}
		/>
	);
}

export default createFragmentContainer(AnalysePageContainer, {
	child_Subs: graphql`
		fragment AnalysePageContainer_child_Subs on SubscriptionNodeConnection {
			edges {
				node {
					id
					source {
						id
						name
					}
				}
			}
		}
	`
});
